// import Swiper JS
import Swiper, {Autoplay,EffectFade } from 'swiper';
Swiper.use([Autoplay,EffectFade ]);




const homeHeroSlider = () => {

	let imageSliderModules = document.querySelectorAll('.m__islider-home-hero');
	if(imageSliderModules){

        console.log('Home Hero Slider found');
		
		imageSliderModules.forEach((imageSliderModule) => {

			if(imageSliderModules.length >= 1){
				//Initialise the slider
				const iSwiper = new Swiper(imageSliderModule.querySelector('.m__islider-home-hero__swiper-wrapper .swiper'), {
					modules: [ EffectFade ],
                    slidesPerView: 1,
                    effect: "fade",
                    fadeEffect: { crossFade: true },
					speed: 2500,
                    grabCursor: false,
					loop: true,
                    allowTouchMove: false,
					autoplay: {
						delay: 1500,
						disableOnInteraction: false,
					  },

                    
				});

			}

		})
		
	}
}


homeHeroSlider();
